// extracted by mini-css-extract-plugin
export default {"row":"styles_row__znxVN","bottom-offset":"styles_bottom-offset__gqOt3"};